import { Route, Routes } from 'react-router-dom'

import Editor from './screens/Editor'
import Settings from './screens/Settings'

// @ts-expect-error TS7006
const CampaignQuoteTemplateEditRoutes = (props) => {
  const { agencyId } = props

  return (
    <Routes>
      <Route path="/" element={<Editor agencyId={agencyId} />} />
      <Route path="/settings" element={<Settings />} />
    </Routes>
  )
}

export default CampaignQuoteTemplateEditRoutes
